import type { SVGProps } from "react";
export default function SvgSharepoint(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			baseProfile="basic"
			viewBox="0 0 48 48"
			{...props}
		>
			<path
				fill="#26c6da"
				d="M20.858 28.467c7.006 0 12.686-5.671 12.686-12.667S27.863 3.133 20.858 3.133 8.172 8.805 8.172 15.8s5.679 12.667 12.686 12.667"
			/>
			<path
				fill="#00acc1"
				d="M32.328 36.911c5.783 0 10.471-4.681 10.471-10.456S38.111 16 32.328 16s-10.471 4.681-10.471 10.456 4.688 10.455 10.471 10.455"
			/>
			<path
				fill="#0097a7"
				d="M22.443 44.972c4.963 0 8.986-4.017 8.986-8.972s-4.023-8.972-8.986-8.972-8.986 4.017-8.986 8.972 4.023 8.972 8.986 8.972"
			/>
			<path
				fill="#00838f"
				d="M8.5 23h10a3.5 3.5 0 0 1 3.5 3.5v10a3.5 3.5 0 0 1-3.5 3.5h-10A3.5 3.5 0 0 1 5 36.5v-10A3.5 3.5 0 0 1 8.5 23"
			/>
			<path
				fill="#fff"
				d="m9.832 34.445 1.846-.962q.312.63.814.928.51.298 1.113.298.673 0 1.024-.271.353-.278.353-.833a.94.94 0 0 0-.339-.732q-.339-.305-1.201-.461-1.642-.298-2.389-1.044-.74-.746-.74-1.856 0-1.382.978-2.209.977-.826 2.579-.826 1.078 0 1.9.44a3.3 3.3 0 0 1 1.303 1.261l-1.805.928q-.299-.461-.644-.664-.346-.21-.869-.21-.625 0-.95.271a.88.88 0 0 0-.319.705q0 .373.305.657.312.278 1.249.454 1.575.298 2.348 1.085.78.778.78 1.972 0 1.45-.93 2.297-.93.846-2.653.847-1.249 0-2.253-.542a3.57 3.57 0 0 1-1.499-1.532z"
			/>
		</svg>
	);
}
